import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const BlankLayout = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const checkUser = () => {
      const user = localStorage.getItem("user");
      if (user) {
        navigate("/dashboard");
      }
    };

    checkUser();
  }, []);
  return <main>{children}</main>;
};

export default BlankLayout;
